import React, { useCallback, useEffect } from 'react';
import { SButton, SNotification } from '@chargebee/sting-react';
import { SuspenseLoader } from '@bbkAdminComponents/loaders/suspense-loader';
import { AuthPanel } from '@bbkAdminComponents/log-in-flow/auth-panel';
import { LogInPaths } from '@bbkAdminComponents/log-in-flow/log-in-paths';
import { brightbackAuthSlice } from '@bbkAdminRedux/rtkq/brightback-auth.slice';

export const LogoutPage: React.FC = () => {
  const [signOut$, { isError, isLoading }] =
    brightbackAuthSlice.endpoints.signOut.useMutation();

  const signOut = useCallback(
    () => signOut$({ redirect: LogInPaths.signIn }),
    [signOut$]
  );

  useEffect(() => {
    const timer = setTimeout(signOut, 1500);
    return () => clearTimeout(timer);
  }, [signOut]);

  // A failed sign-out means the session is still live server-side, so say so
  // rather than showing a spinner forever: the user needs to know they are not
  // signed out, and needs a way to try again.
  if (isError) {
    return (
      <AuthPanel>
        <SNotification
          variant="danger"
          hasBorder
          title="We couldn't sign you out"
          description="Your session is still active. Please try again."
        />
        <div className="tw-mt-6">
          <SButton
            type="button"
            variant="primary"
            size="large"
            fullWidth
            loading={isLoading}
            onClick={() => signOut()}
          >
            Try again
          </SButton>
        </div>
      </AuthPanel>
    );
  }

  return (
    <AuthPanel>
      <div className="tw-text-center">
        <div className="tw-mb-4 tw-font-semibold">Signing you out...</div>
        <div>
          <SuspenseLoader message="" />
        </div>
      </div>
    </AuthPanel>
  );
};
